import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// reset style sheet
import "@/styles/reset.scss";
// CSS common style sheet
import "@/styles/common.scss";
// iconfont
import "@/styles/iconfont.scss";
// vxe-ui
import VxeUI from "vxe-pc-ui";
import "vxe-pc-ui/lib/style.css";
import VxeUITable from "vxe-table";
import "vxe-table/lib/style.css";
import zhCN from "vxe-pc-ui/lib/language/zh-CN";
import CommonElButton from "@/components/CommonElButton.vue";
import "/public/config.js"
// VxeUI.setConfig({
//   zIndex: 3000,
// })
VxeUI.setI18n("zh-CN", zhCN);
VxeUI.setLanguage("zh-CN");

(async () => {
  const app = createApp(App);

  if (process.env.VUE_APP_PLATFORM === "electron") {
    try {
      const cfg = await (window as any).electronApi.loadAppConfig();
      (window as any).__ELECTRON_CFG__ = cfg;
      console.log("[Electron] 全局配置已注入:", cfg);
    } catch (e) {
      console.error("Electron 配置加载失败:", e);
    }
  }

  app.component("CommonElButton", CommonElButton);
  app
    .use(ElementPlus)
    .use(store)
    .use(router)
    .use(VxeUI)
    .use(VxeUITable)
    .mount("#app");
})();
